import React from 'react';
import { StandardImageBanner } from './SectionComponents';
import { breakpoints, colors } from '@web-for-marketing/react-ui';
import { useAtom } from 'jotai';
import { isMobileAtom } from '@atoms/appSettings';
import { ArticleEntity } from '@models/article';

interface ArticleHeaderProps {
    article: ArticleEntity;
}

const classes = {
    headerImageInnerContainer: {
        height: '32rem',
        [`@media (max-width: ${breakpoints.md})`]: {
            height: '20rem',
        },
    },
    bannerImage: {
        display: 'block',
        [`@media (max-width: ${breakpoints.md})`]: {
            display: 'none',
        },
    },
    noMediaBox: {
        height: '30rem',
        backgroundColor: colors.core.cloud,
        display: 'block',
        [`@media (max-width: ${breakpoints.md})`]: {
            display: 'none',
        },
    },
} as const;

export function ArticleHeader({ article }: ArticleHeaderProps): React.ReactElement | null {
    const [isMobile] = useAtom(isMobileAtom);
    const hasImage = !!(article.imageUrl || article.mobileImageUrl);

    if (!hasImage || (article.hideMobileHeaderImage && isMobile)) {
        return null;
    }

    return (
        <div css={article.hideMobileHeaderImage ? classes.bannerImage : undefined}>
            <StandardImageBanner
                imagePath={article.imageUrl}
                mobileImagePath={article.mobileImageUrl}
                alt={article.imageAlt ?? ''}
                mobileAlt={article.mobileHeaderAlt ?? ''}
                disableGradient={isMobile}
                bannerOnTop={isMobile}
                lazyLoad={false}
                customProps={{ noBottomPadding: true }}
            >
                <div css={classes.headerImageInnerContainer} />
            </StandardImageBanner>
        </div>
    );
}
